import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-fluid",
  style: {"margin-top":"80px","padding-top":"20px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "text-muted" }
const _hoisted_5 = { class: "col-lg-6 d-flex flex-column justify-content-end" }

import { computed, onMounted, nextTick, shallowReactive, watch, type Ref } from 'vue'
    import { useRoute } from 'vue-router'

    import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue'
    import PortfolioScenarioNavigation from '@Quest/PortfolioScenarios/Components/PortfolioScenarioNavigation.vue'
    import ProjectsGrid from '@Quest/Projects/Components/ProjectsGrid.vue'

    import { ProjectsGridViewModel } from '@Quest/Projects/Components/ProjectsGrid'
    import { ReviewPageReadModel } from '@Quest/PortfolioScenarios/readmodels'

    import { useReviewPageQueryV1 } from '@Quest/PortfolioScenarios/queries-vue-composables'
    import { useSaveReviewGridCommandV1 } from '@Quest/PortfolioScenarios/commands-vue-composables'


    
export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewPage',
  setup(__props) {

    const route = useRoute()
    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const tchProjectId = computed(() => Number(route.params.tchProjectId ?? 0))
    const scenarioId = computed(() => String(route.params.scenarioId ?? ''))

    const {
        runReviewPageQueryV1,
        modelReviewPageQueryV1
    } = useReviewPageQueryV1(workspaceId, tchProjectId, scenarioId)

    const rm = modelReviewPageQueryV1 as Ref<ReviewPageReadModel | null>
    const portfolioId = computed(() => rm.value?.PortfolioId)

    const grid = shallowReactive(new ProjectsGridViewModel())

    // ======================
    // Commands
    // ======================

    const {
        invokeSaveReviewGridCommandV1,
        onSucceedSaveReviewGridCommandV1
    } = useSaveReviewGridCommandV1(workspaceId, portfolioId, scenarioId)

    // ======================
    // Handlers
    // ======================

    function handleShowGridColumnsEditor()
    {
        grid.showGridColumnsEditor()
    }

    function handleSaveReviewGridCommand()
    {
        const gridJson = grid.getJson()
        invokeSaveReviewGridCommandV1({ Grid: gridJson })
    }

    function handleClearGridFilters()
    {
        grid.clearFilters()
    }

    function handleExportGrid()
    {
        grid.exportGrid()
    }

    function onSelected(result: any)
    {
        // intentionally empty (same as legacy)
    }


    onMounted(() =>
    {
        document.title = "Portfolio Plan - Review"
        runReviewPageQueryV1()
    })


    watch(rm, (current) =>
    {
        if (!current) return

        nextTick(() =>
        {
            grid.renderGrid(
                current.Grid.IdField,
                current.Grid.Fields,
                current.Grid.DefaultFieldIds,
                current.Grid.Options
            )

            grid.setProjects(current.Projects.map(p => p.Properties))
        })
    })

    onSucceedSaveReviewGridCommandV1(() =>
    {
        alert("Saved")
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PortfolioNavigation, {
      workspaceId: workspaceId.value,
      projectId: tchProjectId.value
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    (_unref(rm))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("small", _hoisted_4, _toDisplayString(_unref(rm).PortfolioName) + " / " + _toDisplayString(_unref(rm).ScenarioName), 1 /* TEXT */),
              _cache[0] || (_cache[0] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "Plan: Review", -1 /* CACHED */))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(PortfolioScenarioNavigation, {
                portfolioId: _unref(rm).PortfolioId,
                corporateScenarioUrl: _unref(rm).CorporateScenarioUrl,
                onSelected: onSelected
              }, null, 8 /* PROPS */, ["portfolioId", "corporateScenarioUrl"])
            ])
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
          _cache[5] || (_cache[5] = _createElementVNode("div", {
            class: "alert alert-warning",
            role: "alert"
          }, [
            _createElementVNode("p", { class: "mb-0" }, [
              _createTextVNode(" Please note that project-level data in this report is based on the start date in "),
              _createElementVNode("strong", null, "Kanban"),
              _createTextVNode(" & "),
              _createElementVNode("strong", null, "Active Business Case"),
              _createTextVNode(". ")
            ])
          ], -1 /* CACHED */)),
          _createElementVNode("div", { class: "toolbar" }, [
            _cache[3] || (_cache[3] = _createElementVNode("div", null, [
              _createCommentVNode("<button type=\"button\" class=\"btn btn-outline-secondary\">Action ({{selectedIds.length}})</button>")
            ], -1 /* CACHED */)),
            _createElementVNode("div", null, [
              _createCommentVNode(" Edit + Save View Group "),
              _createElementVNode("div", { class: "btn-group mr-2" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-secondary",
                  onClick: handleShowGridColumnsEditor
                }, " Edit columns "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-secondary",
                  onClick: handleSaveReviewGridCommand,
                  title: "Save current grid layout and filters"
                }, " Save view ")
              ]),
              _createCommentVNode(" Actions Dropdown "),
              _createElementVNode("div", { class: "btn-group" }, [
                _cache[2] || (_cache[2] = _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-secondary dropdown-toggle",
                  "data-toggle": "dropdown"
                }, " Actions ", -1 /* CACHED */)),
                _createElementVNode("div", { class: "dropdown-menu dropdown-menu-right" }, [
                  _createElementVNode("button", {
                    class: "dropdown-item",
                    onClick: handleExportGrid
                  }, [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("i", { class: "fa fa-download fa-sm mr-1" }, null, -1 /* CACHED */),
                    _createTextVNode(" Download to spreadsheet ", -1 /* CACHED */)
                  ]))]),
                  _createElementVNode("button", {
                    class: "dropdown-item",
                    onClick: handleClearGridFilters
                  }, " Clear Filters ")
                ])
              ])
            ])
          ]),
          _createVNode(ProjectsGrid, { viewModel: _unref(grid) }, null, 8 /* PROPS */, ["viewModel"])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})